<template>
    <v-snackbar
    :color="color"
    :timeout="timer"
    v-model="showSnackbar"
    style="z-index: 9999"
    >
    <v-icon left>{{icon}}</v-icon> {{message}}

    <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click.stop="showSnackbar = false">
            Fechar
        </v-btn>
    </template>

    </v-snackbar>
</template>

<style lang="sass">
$snackbar-absolute-z-index: 300
</style>

<script lang="ts">


export default {
    name: "vToast",
    data() {
        return {
            showSnackbar:false,
            message:'',
            color:'success',
            icon:'mdi-check',
            timer: 3000
        }
    },
    methods:{
        show(data){
            this.message = data.message || 'missing "message"';
            this.color = data.color || 'success';
            this.icon = data.icon || 'mdi-check'
            this.showSnackbar = true;
        },
        error(message){
            this.show({message:message, color:'red', icon:'mdi-alert-circle'})
        },
        success(message){
            this.show({message:message})
        }
    }
}
</script>
